import { Alert, Button, Card, Center, Input, PasswordInput, Space, Stack, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { ChangeEvent, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import tangerineIcon from '../../assets/images/bridge-ad_logo_clear.png'
import useAuth from '../../hooks/api/useAuth'

function Login() {
  const navigate = useNavigate()
  const [opened, { open, close }] = useDisclosure(false)
  const [form, setForm] = useState({ username: '', password: '' })
  const { signIn } = useAuth()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = () => {
    signIn(form.username, form.password)
      .then(() => {
        navigate('/dashboard')
      })
      .catch(() => {
        open()
      })
  }

  return (
    <Center w='100vw' h='100vh' bg='gray.0'>
      <Stack align='center'>
        <img src={tangerineIcon} alt='tangerine_icon' width={400} />
        <Card w='350px' shadow='sm' padding='40px 40px 70px' radius='md' withBorder>
          <Stack w='100%' align='center'>
            <Title order={3}>ログイン</Title>
            <Space h={0} />
            <Input.Wrapper w='100%' label='ユーザ名' required>
              <Input name='username' value={form.username} onChange={handleChange} />
            </Input.Wrapper>
            <Input.Wrapper w='100%' label='パスワード' required>
              <PasswordInput name='password' value={form.password} onChange={handleChange} />
            </Input.Wrapper>
            <Space h={0} />
            <Button
              w='100%'
              mt={20}
              color='#00CC00'
              type='button'
              onClick={handleSubmit}
              // disabled={form.username.length === 0 || form.password.length === 0}
            >
              ログイン
            </Button>
          </Stack>
        </Card>
        <Link to='/forgot-password' className='text-sm font-semibold border-b border-b-[#00CC00] text-[#00CC00]'>
          パスワードを忘れた方はこちら
        </Link>
      </Stack>
      {opened && (
        <Alert className='!absolute top-16' variant='light' color='red' title='エラー' withCloseButton onClose={close}>
          ログインに失敗しました。ユーザ名とパスワードを確認してください。
        </Alert>
      )}
    </Center>
  )
}

export default Login
